import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Content, Title, Subtitle, HomeButton } from './styles';
import hero from '~/assets/banners/hero-home-new.png';

const NotFound: React.FC = () => {
  return (
    <Container>
      <Link to={`${process.env.PUBLIC_URL}/`}>
        <img src={hero} alt="Koro" className="logo w-100" />
      </Link>
      <Content className="mt-5 pt-4">
        <Title>404</Title>
        <Subtitle>Página não encontrada</Subtitle>
        <p className="description">
          Ops! O endereço que você tentou acessar não existe ou foi removido.
        </p>

        <HomeButton to={`${process.env.PUBLIC_URL}/`}>
          Ir para a página inicial
        </HomeButton>
      </Content>
    </Container>
  );
};

export default NotFound;
